import React from 'react'

const GovernmentName = props => <div className="gov-name text-right">
    <h3 className="gov-name__header">{props.name}</h3>
</div>

export default GovernmentName
